"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = releaseNotes;
const times_1 = __importDefault(require("lodash/times"));
const getExistingReleaseBranch_1 = __importDefault(require("../release/getExistingReleaseBranch"));
const releaseUtils_1 = __importDefault(require("../release/releaseUtils"));
function releaseNotes(execSync, prompt, confluenceReleaseNotesLink) {
    const mainBranch = releaseUtils_1.default.getMainBranchName(execSync);
    let version = '';
    function getReleaseHotfixBranchDiffCmd() {
        try {
            const selectedBranch = (0, getExistingReleaseBranch_1.default)(execSync, prompt);
            console.log(`Creating release notes for "${selectedBranch}"`);
            version = releaseUtils_1.default.calculateReleaseVersion(selectedBranch.split('--')[1]);
            return `git log --color=never origin/${mainBranch}..origin/${selectedBranch}`;
        }
        catch (e) {
            console.log('No release or hotfix branch detected! Exiting!');
            process.exit(1);
            return null;
        }
    }
    function getReleasedVersionDiffCmd() {
        const latestTag = prompt('Enter the a release number/tag (e.g. 1.9.0): ');
        const previousTag = prompt('Enter the release number/tag to compare to (e.g. 1.8.0): ');
        console.log(`Creating release notes for ${latestTag}, compared against ${previousTag}`);
        version = releaseUtils_1.default.calculateReleaseVersion(latestTag);
        return `git log --color=never refs/tags/${latestTag}...refs/tags/${previousTag}`;
    }
    const notesCmdMap = {
        1: getReleaseHotfixBranchDiffCmd,
        2: getReleasedVersionDiffCmd,
    };
    execSync('git fetch -p', { stdio: 'inherit' });
    console.log('\n');
    const releaseNotesSelection = prompt(`
  What would you like to generate release notes for?

  1) Release notes for a release/hotfix/minor-release branch.
  2) Release notes a version that's already been released.

  Please type 1 or 2, and hit enter: `);
    if (!['1', '2'].includes(releaseNotesSelection)) {
        console.log('You need to type 1 or 2 only! Try again!');
        process.exit(1);
    }
    console.log('\n');
    const baseCompareCommand = notesCmdMap[releaseNotesSelection]();
    console.log('\n');
    const confluenceChangelog = execSync(`${baseCompareCommand} --pretty=format:'|%s|%an|%h|%ai|'`);
    const emailChangelog = execSync(`${baseCompareCommand} --pretty=format:'%s\t%an\t%h\t%ai'`);
    const confluenceChangelogWithColumns = `||Commit Message||Author||Commit SHA||Author Date||\n${confluenceChangelog.toString()}`;
    const emailChangelogWithColumns = `Commit Message\tAuthor\tCommit SHA\tAuthor Date\n${emailChangelog.toString()}`;
    console.log((0, times_1.default)(140, () => '#').join(''));
    console.log(`${(0, times_1.default)(57, () => '#').join('')} CONFLUENCE RELEASE NOTES ${(0, times_1.default)(57, () => '#').join('')}`);
    console.log((0, times_1.default)(140, () => '#').join(''));
    console.log('\nFirst, copy everything between the lines below:\n');
    console.log((0, times_1.default)(140, () => '=').join(''));
    console.log(`New platform version number is ${version}`);
    console.log('\n');
    console.log(confluenceChangelogWithColumns);
    console.log((0, times_1.default)(140, () => '=').join(''));
    console.log('\n');
    console.log(`
  On the release notes Confluence page (${confluenceReleaseNotesLink}), follow these steps:
    1) Find the spot where you want to pop in the new release notes.
    2) Press the [cmd] [shift] D keys.
    3) Paste the above log output into the left hand panel.
    4) Click the 'Insert' button.
  `);
    console.log('\n\n');
    console.log((0, times_1.default)(140, () => '#').join(''));
    console.log(`${(0, times_1.default)(60, () => '#').join('')} EMAIL RELEASE NOTES ${(0, times_1.default)(59, () => '#').join('')}`);
    console.log((0, times_1.default)(140, () => '#').join(''));
    console.log('\nFirst, copy everything between the lines below:\n');
    console.log((0, times_1.default)(140, () => '=').join(''));
    console.log(`New platform version number is ${version}`);
    console.log('\n');
    console.log(emailChangelogWithColumns);
    console.log((0, times_1.default)(140, () => '=').join(''));
    console.log('\n');
    console.log(`
  Paste the contents in some dummy Excel or Google Sheets sheet (paste values only), format, and then recopy.

  After that, go ahead and paste into your email; the contents should automatically be formatted into a table.

  ...and that's it! Have fun!
  `);
}
